import React, { useState, useEffect, useRef } from "react"

const calcShown = () => Math.min(3, Math.floor(window.innerWidth / 400));

const Carousel = ({children, ...props}) => {
  const height = '20rem', nitems = React.Children.count(children);

  const [nshown, setNshown] = useState(calcShown());
  const [pos, setPos] = useState(0);

  const animDiv = useRef();

  useEffect(() => {
    window.addEventListener('resize', () => setNshown(calcShown()));
  }, []);

  useEffect(() => {
    const startAnim = () => {
      animDiv.current.style.transition = '';
      animDiv.current.style.transform = '';
      setTimeout(() => {
        if (animDiv.current && animDiv.current.firstChild) {
          animDiv.current.style.transition = `transform ${nitems * 10}s linear`;
          animDiv.current.style.transform = `translate(-${animDiv.current.firstChild.clientWidth}px, 0)`;
        }
      });
    };
    if (animDiv.current) {
      animDiv.current.addEventListener('transitionend', startAnim);
    }
    startAnim();
    return () => {
      if (animDiv.current) {
        animDiv.current.removeEventListener('transitionend', startAnim);
      }
    };
  }, [nshown]);

  const childrenDiv = <div className="flex items-stretch">{React.Children.map(children, (child, i) => (
    <div key={i} className="flex-1 bg-white rounded-lg p-8 m-6" style={{boxShadow: 'rgba(25, 28, 31, 0.08) 0px 14px 32px, rgba(25, 28, 31, 0.04) 0px 8px 16px, rgba(25, 28, 31, 0.04) 0px -1px 0px'}}>
      {child}
    </div>
  ))}</div>;

  return <div {...props}>
    <div className="relative" style={{height: height}}>
      <div className="absolute flex items-stretch" ref={animDiv} style={{
          width: (nitems/nshown*200) + '%',
          height: height
        }}>
        {childrenDiv}
        {childrenDiv}
      </div>
      <div className="absolute left-0 top-0 bottom-0 w-1/12" style={{background: 'linear-gradient(to right, white, rgba(255, 255, 255, 0))'}}></div>
      <div className="absolute right-0 top-0 bottom-0 w-1/12" style={{background: 'linear-gradient(to left, white, rgba(255, 255, 255, 0))'}}></div>
    </div>
  </div>;
};

export default Carousel;
